export default class ProcessProgress {
    current = 0;
    total = 0;
}